import { render, staticRenderFns } from "./LatestBlocks.vue?vue&type=template&id=931f67fc&"
import script from "./LatestBlocks.vue?vue&type=script&lang=ts&"
export * from "./LatestBlocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports